import React from "react"
import SideNav from "components/SideNav"

const menus = [
    {
        title: "메인",
        subMenus: [
            {
                title: "의원 관리",
                to: "/main/clinic",
            },
            {
                title: "의료진 관리",
                to: "/main/doctor",
            },
            {
                title: "이벤트 관리",
                to: "/main/event",
            },
            {
                title: "리뷰 관리",
                to: "/main/review",
            },
            {
                title: "상담 관리",
                to: "/main/counsel",
            },
        ],
    },
    {
        title: "사용자 관리",
        subMenus: [
            {
                title: "직원 관리",
                to: "/user/staff",
            },
            {
                title: "파트너 관리",
                to: "/user/partner",
            },
            {
                title: "회원 관리",
                to: "/user/member",
            }
        ],
    },
    {
        title: "카테고리 관리",
        subMenus: [
            {
                title: "진료과목",
                to: "/category/specialty",
            },
            {
                title: "시술명",
                to: "/category/treatment",
            },
            {
                title: "시술부위",
                to: "/category/part",
            },
            {
                title: "고민",
                to: "/category/concern",
            },
        ],
    },
    {
        title: "문서 관리",
        subMenus: [
            {
                title: "입점 신청",
                to: "/document/apply",
            },
        ],
    },
    {
        title: "계정",
        subMenus: [
            {
                title: "마이페이지",
                to: "/account/my-page",
            },
        ],
    },
    // {
    //     title: "테스트",
    //     subMenus: [
    //         {
    //             title: "이미지 업로드",
    //             to: "/test/img-upload",
    //         },
    //         {
    //             title: "파일 업로드",
    //             to: "/test/file-upload",
    //         },
    //         {
    //             title: "주소검색",
    //             to: "/test/address-search",
    //         },
    //         {
    //             title: "폼",
    //             to: "/test/forms",
    //         },
    //         {
    //             title: "게시판",
    //             to: "/test/board",
    //         },
    //         {
    //             title: "소셜로그인",
    //             to: "/test/oauth",
    //         },
    //     ],
    // }
]

export default () => {
    return (
        <SideNav menus={menus}></SideNav>
    )
}